import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '@nrwl/common-lib';
import { cloneDeep } from 'lodash';
@Injectable({
  providedIn: 'root'
})
export class JmepConfigureService {
  jmepImages = [];
  isAvailableUpgradeImages: boolean;
  getJmepConfigPath = '/uicomm/getJMEPConfig';
  setJMEPConfigPath = '/uicomm/setJMEPConfig';
  getJmepImagesListPath = '/uicomm/getJmepImageFiles';
  jmep10gVersionOne = ['10.0', '10.1'];
  private readonly unsubscribe: Subject<void> = new Subject();
  constructor(private readonly apiService: ApiService) {}

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  getFormValueByAttributes(configData, fieldMapping): any {
    const attributeValues = this.getProbeAttibuteValues(
      configData,
      fieldMapping.section,
      fieldMapping.attributes
    );
    const dataObject = fieldMapping.dataMapping.find(
      data => JSON.stringify(data.dataValue) === JSON.stringify(attributeValues)
    );
    return dataObject ? cloneDeep(dataObject.formValue) : cloneDeep(fieldMapping.defaultValue);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  getProbeAttibuteValues(
    // eslint-disable-next-line
    configData,
    sectionName: string,
    fieldNames: Array<any>,
    defaultValue = 'false'
  ): any {
    const valuesArray = [];
    if (configData && configData.value && configData?.value?.data && configData) {
      const section = this.findByValue(configData.value.data, 'name', sectionName);
      if (section && section.subAttributes) {
        fieldNames.forEach(names => {
          const propertyObject = this.findByValue(section.subAttributes, 'id', names);
          const attributeValue =
            propertyObject && propertyObject.value ? propertyObject.value : defaultValue;
          valuesArray.push(attributeValue);
        });
      }
    }
    return valuesArray;
  }
  //eslint-disable-next-line
  findByValue(data: Array<any>, key: string, value: string): any {
    return data.find(item => item[key] === value);
  }
  //eslint-disable-next-line
  getJMEPConfig(reqData): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.getJmepConfigPath}`, { reqData: reqData });
  }
  //eslint-disable-next-line
  setJMEPConfig(reqData): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(`${this.setJMEPConfigPath}`, { reqData: reqData });
  }

  //eslint-disable-next-line
  getjmepImagesList(): Observable<any> {
    //eslint-disable-next-line
    return this.apiService.post$<any>(this.getJmepImagesListPath);
  }

  //eslint-disable-next-line
  loadJmepV1EditConfig(model, version): boolean {
    const jmep3VersionTwo = '3.0.3'; // JMEP-3 version 3.0.3.x and newer will support the Test IP feature
    const jmep2Version = '2.2.0.300';
    const isJmep10gVersionOne = version ? this.isJmep10versionOne(version) : false;
    const jmapMajorVersion = version ? version.split('.')[0] : null;
    let loadVersion1Config = true;
    if (model === 'JMEP-10G' && !isJmep10gVersionOne) {
      loadVersion1Config = false; // JMEP-10 version 10.2.x.x and newer will support the Test IP feature
    } else if (
      model === 'JMEP-1G' &&
      ((jmapMajorVersion === '3' &&
        version.localeCompare(jmep3VersionTwo, undefined, {
          numeric: true,
          sensitivity: 'base'
        }) !== -1) ||
        (jmapMajorVersion === '2' &&
          version.localeCompare(jmep2Version, undefined, { numeric: true, sensitivity: 'base' }) !==
            -1))
    ) {
      loadVersion1Config = false;
    }
    return loadVersion1Config;
  }
  isJmep10versionOne(version: string): boolean {
    const majorMinorVersion = this.getMajorMinorVersion(version);
    return this.jmep10gVersionOne.indexOf(majorMinorVersion) !== -1;
  }
  getMajorMinorVersion(version: string): string {
    let majorMinorVersion = version;
    if (typeof version === 'string') {
      const versionParts = version.split('.');
      if (versionParts && versionParts.length >= 2) {
        majorMinorVersion = versionParts[0] + '.' + versionParts[1];
      }
    }
    return majorMinorVersion;
  }

  parseErrorMessage(errorString: string): string {
    let errorMessage = '';
    const regex = /"error-message"\s*:\s*"([^"]+)"/;
    const match = errorString.match(regex);
    if (match && match[1]) {
      return match[1];
    }
    return errorMessage;
  }

  dispose(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
